"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var $dyn;
(function ($dyn) {
    Globalize.addCultureInfo("en", {
        messages: {
            FilterField_PillAriaLabel: "Filter value of {0}",
            FilterField_PillContainerDeleteDescription: "Delete selected filter value",
            FilterField_PillContainerMoveDownDescription: "Select next displayed filter value",
            FilterField_PillContainerMoveFirstDescription: "Select first displayed filter value",
            FilterField_PillContainerMoveLastDescription: "Select last displayed filter value",
            FilterField_PillContainerMoveUpDescription: "Select previous displayed filter value",
        }
    });
    var controls;
    (function (controls) {
        var FilterFieldPillList = /** @class */ (function (_super) {
            __extends(FilterFieldPillList, _super);
            function FilterFieldPillList(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                _this.list = element.firstChild;
                // IsOneOfFilterFieldContent extends $dyn.ui.Control and parent is container and hence we have to cast as any first.
                _this.Parent = parent;
                _this.SelectedIndex = $dyn.observable(0);
                _this.Values = (_this.Parent.CappedValues && _this.Parent.CappedValues) || $dyn.observableObject($dyn.observable([]));
                // Whenever the values change, reset the selected index
                $dyn.observe(_this.Values, function () {
                    $dyn.setValue(_this, "SelectedIndex", 0);
                });
                return _this;
            }
            /**
             * Executed whenever a pill's delete button is clicked.
             * @internal
             * @param index The index of the pill for which the delete button was clicked.
             */
            FilterFieldPillList.prototype.DeletePillButtonClicked = function (index) {
                this.DeleteSelectedPill(index);
                this.list.focus();
            };
            /**
             * Executed whenever a key down event occurs within the pill list.
             * @internal
             * @param event The key down event.
             */
            FilterFieldPillList.prototype.keyDown = function (event) {
                $dyn.util.handleShortcuts(this, event);
            };
            /**
             * Deletes the selected pill and corresponding value, adjusting selection index and setting appropriate focus.
             * @internal
             * @param selectedIndex The index of the selected pill to delete.
             */
            FilterFieldPillList.prototype.DeleteSelectedPill = function (selectedIndex) {
                this.Parent.Values.splice(selectedIndex, 1);
                var numberOfValues = $dyn.length(this.Values);
                if (numberOfValues > 0) {
                    var lastIndex = numberOfValues - 1;
                    if (selectedIndex > lastIndex) {
                        selectedIndex = lastIndex;
                    }
                    if (selectedIndex !== $dyn.value(this.SelectedIndex)) {
                        $dyn.setValue(this, "SelectedIndex", selectedIndex);
                    }
                }
                else {
                    this.Parent.FocusInput();
                }
            };
            /**
             * Executed whenever a key down event occurs within the pill list.
             * below function starting with caps K is kept for backward compatibility, as it was in old filtering.js file.
             * all other control has this function with small k and hence a new function is created with small k and that should be used
             * @deprecated This is deprecated at 08/05/2020.Remove it TFS(478168).
             */
            FilterFieldPillList.prototype.KeyDown = function (event) {
                this.keyDown(event);
            };
            return FilterFieldPillList;
        }($dyn.ui.Control));
        controls.FilterFieldPillList = FilterFieldPillList;
        // tslint:disable:object-literal-sort-keys
        var filterFieldPillListShortcuts = {
            Delete: {
                Keys: { keyCode: [$dyn.ui.KeyCodes.backSpace, $dyn.ui.KeyCodes.deleteKey] },
                Handler: function () {
                    this.DeleteSelectedPill($dyn.value(this.SelectedIndex));
                    return true;
                },
                RecordTelemetry: false,
                Description: $dyn.label("FilterField_PillContainerDeleteDescription"),
                Category: $dyn.ui.ShortcutCategory.ElementAction
            },
            MoveUp: {
                Keys: { keyCode: $dyn.ui.KeyCodes.upArrow },
                Handler: function () {
                    var selectedIndex = $dyn.value(this.SelectedIndex);
                    if (selectedIndex > 0) {
                        $dyn.setValue(this, "SelectedIndex", selectedIndex - 1);
                    }
                    return true;
                },
                RecordTelemetry: false,
                Description: $dyn.label("FilterField_PillContainerMoveUpDescription"),
                Category: $dyn.ui.ShortcutCategory.ElementAction
            },
            MoveDown: {
                Keys: { keyCode: $dyn.ui.KeyCodes.downArrow },
                Handler: function () {
                    var selectedIndex = $dyn.value(this.SelectedIndex);
                    if (selectedIndex < ($dyn.length(this.Values) - 1)) {
                        $dyn.setValue(this, "SelectedIndex", selectedIndex + 1);
                    }
                    return true;
                },
                RecordTelemetry: false,
                Description: $dyn.label("FilterField_PillContainerMoveDownDescription"),
                Category: $dyn.ui.ShortcutCategory.ElementAction
            },
            MoveFirst: {
                Keys: { keyCode: $dyn.ui.KeyCodes.home },
                Handler: function () {
                    var selectedIndex = $dyn.value(this.SelectedIndex);
                    if (selectedIndex !== 0) {
                        $dyn.setValue(this, "SelectedIndex", 0);
                    }
                    return true;
                },
                RecordTelemetry: false,
                Description: $dyn.label("FilterField_PillContainerMoveFirstDescription"),
                Category: $dyn.ui.ShortcutCategory.ElementAction
            },
            MoveLast: {
                Keys: { keyCode: $dyn.ui.KeyCodes.end },
                Handler: function () {
                    var lastIndex = ($dyn.length(this.Values) - 1);
                    if (lastIndex !== -1 && $dyn.value(this.SelectedIndex) !== lastIndex) {
                        $dyn.setValue(this, "SelectedIndex", lastIndex);
                    }
                    return true;
                },
                RecordTelemetry: false,
                Description: $dyn.label("FilterField_PillContainerMoveLastDescription"),
                Category: $dyn.ui.ShortcutCategory.ElementAction
            }
        };
        FilterFieldPillList.prototype.Shortcuts = $dyn.extendPrototype(FilterFieldPillList.prototype.Shortcuts, filterFieldPillListShortcuts);
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=FilterFieldPillList.js.map
